import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import Autorenew from "@material-ui/icons/Autorenew";
import IconButton from "@material-ui/core/IconButton";
import { Badge, Button, Table } from "reactstrap";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import Edithost from "./Edit";
import HostManagement from "./HostManagement.js";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import HostTable from "./HostTable";

export default function Host(props) {
  window.sessionStorage.removeItem("userdata");
  const [state, setState] = useState({
    hostname: window.sessionStorage.getItem("hostname"),
    ip_dns: window.sessionStorage.getItem("ip_dns"),
    jumphost_id: window.sessionStorage.getItem("jumphost_id"),
    os_type: "",
    credential_id: window.sessionStorage.getItem("credential_id"),
    errorMessage: "",
    delete_id: "",
  });

  const [open2, setOpen2] = useState(false);
  const [focusAfterClose2] = useState(true);
  const toggle2 = () => setOpen2(!open2);

  const [one, setone] = React.useState(false);

  const oneopen = () => {
    setone(true);
  };

  const oneClose = () => {
    setone(false);
  };

  const [hostlist, setlists] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationhostlist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setlists(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });

    fetch(`${process.env.REACT_APP_API_URL}/api/run_audit`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("audit_run_limit", data.detail);
        }
      });
  }, []);

  const Connect = (hostId) => {
    let con = {
      host_id: hostId.toString(),
    };
    return function () {
      fetch(`${process.env.REACT_APP_API_URL}/api/connect_host`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
        body: JSON.stringify(con),
      }).then((response) => response.json());
    };
  };

  const Delete = (hostId) => {
    const host = {
      hostname: "",
      ip_dns: "",
      jumphost_id: "",
      os_type: "",
      credential_id: "",
      is_active: "0",
      port: "",
    };
    return function () {
      fetch(
        `${process.env.REACT_APP_API_URL}/api/updatetodeactivate/${hostId}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("token"),
          },
          body: JSON.stringify(host),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          toggle2();
          setone(false);
          window.location.reload();
        })
        .catch((error) => {
          toggle2();
          console.log(error);
        });
      toggle2();
    };
  };
  function refreshPage() {
    window.location.reload();
  }
  function del(deleteid) {
    setState({ delete_id: deleteid });
  }

  const unique = [
    ...new Set(
      hostlist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const [searchitems, setSearchItems] = React.useState(0);
  return (
    <>
      <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
        <div className="relative flex flex-wrap items-stretch">
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Hostname here..."
            onChange={(event) => {
              console.log(event.target.value);
              setSearchItems(event.target.value);
            }}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div>
      </form>
      <br />
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
        <Dialog
          PaperProps={{
            sx: {
              width: "80%",
            },
          }}
          open={one}
          TransitionComponent={Transition}
          keepMounted
          onClose={oneClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            Delete Host
          </h2>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete{" "}
              <strong>
                {window.sessionStorage.getItem("specifyhostname")}
              </strong>{" "}
              ?{" "}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <button
              className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={() => refreshPage()}
            >
              Close
            </button>
            <button
              className="bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={Delete(state.delete_id)}
            >
              Delete
            </button>
          </DialogActions>
        </Dialog>
        <HostTable
          customers={unique}
          del={del}
          oneopen={oneopen}
          Connect={Connect}
          searchitems={searchitems}
        />
      </div>
    </>
  );
}
